import {
  UsersResponse,
  RequestUsersParams,
  InviteUserParams,
} from "../pages/users/types";
import { AuthResponse, User } from "./types";
import { api } from "../api";

export async function loginApi(
  email: string,
  password: string,
): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>("/api/auth/login", {
    email,
    password,
  });
  return data;
}

export async function registerApi(
  token: string | null,
  password: string,
): Promise<void> {
  await api.post<AuthResponse>("/api/auth/invite/accept", {
    token,
    password,
  });
}

export async function resetConfirmApi(
  token: string | null,
  password: string,
): Promise<void> {
  await api.post<AuthResponse>("/api/auth/password-reset/confirm", {
    token,
    password,
  });
}

export async function refreshAccessTokenApi(
  refresh_token: string,
): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>("/api/auth/refresh", {
    refresh_token,
  });
  return data;
}

export async function logoutApi(): Promise<void> {
  await api.post<UsersResponse>(`/api/auth/logout`);
}

export async function getUserApi(): Promise<User> {
  const { data } = await api.get<User>("/api/auth/me");
  return data;
}

export async function getUsersApi(
  params: RequestUsersParams,
): Promise<UsersResponse> {
  const { data } = await api.get<UsersResponse>("/api/users", { params });
  return data;
}

export async function inviteUserApi(params: InviteUserParams): Promise<void> {
  await api.post<void>("/api/auth/invite", {
    ...params,
  });
}

export async function resendInvitationApi(params: {
  user_id: number;
}): Promise<void> {
  await api.post<void>("/api/auth/invite/resend", {
    ...params,
  });
}

export async function resetApi(email: string): Promise<void> {
  await api.post<void>("/api/auth/password-reset", {
    email,
  });
}
